import React, {Component} from 'react'
import "./Cell.css"

class Cell extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  // only render when this is true!
  shouldComponentUpdate(nextProps){
    return this.props.isLit !== nextProps.isLit
  }

  handleClick() {
    // call up to the board to flip cells around this cell
    this.props.flipCellsAroundMe(this.props.coord);
    this.props.clickCounter();
  }

  render() {
    let classes = "Cell" + (this.props.isLit ? " Cell-lit" : "");

    return (
        <td className={classes} onClick={this.handleClick} />
    )
  }
}


export default Cell